import React, { useEffect, useRef, useState } from 'react';
import './Futures.css';
import './LeftParagraph.css';
import { base_url } from './Constants.js';

const PhaseSection = ({ title, description, backgroundColor, svgPath }) => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.2, // Trigger when 20% of the section is visible
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div
            className="phase-background"
            ref={sectionRef}
            style={{ backgroundColor }}
        >
            <div className="phase-content-container">
                <div className="phase-text-title">{title}</div>
                <div className="phase-object-container">
                    <div className="object-container">
                        {isVisible ? (
                            <object
                                className="svg-object"
                                type="image/svg+xml"
                                data={base_url + svgPath}
                            >
                                Loading...
                            </object>
                        ) : (
                            <div className="loading-indicator">Preparing...</div>
                        )}
                    </div>
                </div>
                <div className="phase-text-description">{description}</div>
            </div>
        </div>
    );
};

const Futures = () => {
    const phases = [
        {
            title: "Sense",
            backgroundColor: "rgb(209, 160, 242)",
            description: "Understand the user, challenge assumptions, discover new opportunities, and find patterns in signals of change.",
            svgPath: "/images/project-futures/arrows/sense_making.svg"
        },
        {
            title: "Map",
            backgroundColor: "rgb(30, 50, 100)",
            description: "Extrapolate signals, crystalize trends, reveal shifts, radical alternatives, new products or services, craft narratives, envision future worlds, build prototypes and experiment.",
            svgPath: "/images/project-futures/arrows/world_building.svg"
        },
        {
            title: "Make",
            backgroundColor: "rgb(241, 119, 137)",
            description: "Explore relationships and implications, move beyond the known, prioritize futures, roadmap and align around the products and services, build capacities, create the products and services manifesting change.",
            svgPath: "/images/project-futures/arrows/change_making.svg"
        }
    ];

    return (
        <div className="futures-component">
            <div className="futures-container">
                <h1 className="futures-title">Futures Design</h1>
                <p className="left-paragraph">
                    A unique approach developed over years of practicing design, strategy, and bringing futures to life through the novel use of technology. And a forth coming book offering a step-by-step guide integrating design principles with forwad-thinking approaches. Empowering the responsible creation of innovative products, services, and experiences that bring desired futures to life.
                </p>
            </div>
            {phases.map((phase, index) => (
                <PhaseSection
                    key={index}
                    title={phase.title}
                    backgroundColor={phase.backgroundColor}
                    description={phase.description}
                    svgPath={phase.svgPath}
                />
            ))}
        </div>
    );
};

export default Futures;
